module.exports = __webpack_public_path__ + "img/sophos-logo.405ebfa8.png";